import * as React from "react";
const SvgFiRrCakeSlice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cake-slice_svg__a)">
      <path
        fill="#062147"
        d="M22.896 8.593c-1.215-2.062-3.378-5.055-6.78-7.597-.89-.664-1.968-.991-3.081-.996a5.23 5.23 0 0 0-2.844.881c-.062.042-8.547 8.984-8.547 8.984a5.97 5.97 0 0 0-1.645 4.127v5.007c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-6.35a8 8 0 0 0-1.104-4.057zM2 14h20v3H2zm9.389-11.512A3.23 3.23 0 0 1 13.059 2a3 3 0 0 1 1.86.598c3.135 2.344 5.132 5.106 6.254 7.011.431.731.699 1.547.79 2.391H2.531a4 4 0 0 1 .566-.758zM19 22H5c-1.654 0-3-1.346-3-3h20c0 1.654-1.346 3-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cake-slice_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCakeSlice;
